module.exports = __webpack_public_path__ + "img/img102.35b70ae5.svg";